module.exports = __webpack_public_path__ + "img/box_bonus_disable.44aa911b.png";